import { useState, useEffect } from 'react'

/**
 * Detects if the user prefers reduced motion.
 * Use this to disable animations for accessibility.
 *
 * Usage:
 *   const prefersReducedMotion = useReducedMotion()
 *   const animationProps = prefersReducedMotion ? {} : { initial, animate, exit }
 */
export function useReducedMotion(): boolean {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  })

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
    const handler = (event: MediaQueryListEvent) => {
      setPrefersReducedMotion(event.matches)
    }

    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  return prefersReducedMotion
}
